<script>
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectLabel'],

  computed: {
    itemIcon() {
      if (this.pending) return 'i-lucide-loader-circle animate-spin';
      if (this.selected) return 'i-lucide-circle-check';
      return '';
    },
  },

  methods: {
    onSelect(event) {
      event?.preventDefault?.();
      if (this.pending) return;
      this.$emit('selectLabel', this.title);
    },
  },
};
</script>

<template>
  <woot-dropdown-item>
    <NextButton
      slate
      ghost
      teal
      trailing-icon
      :icon="itemIcon"
      class="w-full !px-2.5 justify-between"
      :class="{ '!flex-row': !selected && !pending }"
      :aria-busy="pending"
      :disabled="pending"
      @click="onSelect"
    >
      <div class="flex items-center min-w-0 gap-2">
        <div
          v-if="color"
          class="size-3 flex-shrink-0 rounded-full outline outline-1 outline-n-weak"
          :style="{ backgroundColor: color }"
        />
        <span
          class="overflow-hidden text-ellipsis whitespace-nowrap leading-[1.1]"
          :title="title"
        >
          {{ title }}
        </span>
      </div>
    </NextButton>
  </woot-dropdown-item>
</template>
